import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { roleuser } from '@edulastic/constants'

import { SubHeaderWrapper, StyledTabPane, StyledSubMenu } from './styled'

import { getUserRole, getDataWarehouseReports } from '../../../selectors/user'
import { createTabBarRenderer, GROUP_SUB_HEADER_FROM } from './renderTabBar'

const AdminHeader = ({
  active,
  role,
  history,
  premium,
  isDataWarehouseReportsEnabled,
}) => {
  const isDistrictAdmin =
    [...roleuser.DA_SA_ROLE_ARRAY, roleuser.EDULASTIC_ADMIN].includes(role) &&
    (premium || isDataWarehouseReportsEnabled)

  useEffect(() => {
    const { state } = history.location
    if (state?.from === GROUP_SUB_HEADER_FROM && history.action !== 'POP') {
      const activeTabElement = document.querySelector(
        '.ant-tabs-tab[aria-selected="true"]'
      )
      if (activeTabElement) {
        activeTabElement.focus()
      }
    }
    // set tabindex to -1 to prevent focus on tabs bar to avoid additional focus stop
    const bar = document.querySelector('.ant-tabs-bar')
    if (bar) bar.setAttribute('tabindex', '-1')
  }, [])

  const onSubTab = (key) => {
    if (key === 'Collaboration-Groups') {
      history.push(`/author/groups/collaborations`, {
        from: GROUP_SUB_HEADER_FROM,
      })
      return
    }

    history.push(`/author/groups/students`, {
      from: GROUP_SUB_HEADER_FROM,
    })
  }

  return (
    <SubHeaderWrapper>
      {active.mainMenu === 'Groups' && (
        <StyledSubMenu
          mode="horizontal"
          defaultActiveKey={active.subMenu}
          onTabClick={onSubTab}
          renderTabBar={createTabBarRenderer(active.subMenu)}
        >
          {isDistrictAdmin && (
            <StyledTabPane
              tab="Collaboration Groups"
              key="Collaboration-Groups"
            />
          )}

          {isDistrictAdmin && (
            <StyledTabPane tab="Student Groups" key="Student-Groups" />
          )}
        </StyledSubMenu>
      )}
    </SubHeaderWrapper>
  )
}

export default connect(
  (state) => ({
    role: getUserRole(state),
    premium: state.user.user?.features?.premium,
    isDataWarehouseReportsEnabled: getDataWarehouseReports(state),
  }),
  {}
)(AdminHeader)
